import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import New from "./new/New";
import Reserve from "./new/Reserve";
import Active from "../../lib/Active";
import useUrlState from "@ahooksjs/use-url-state";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import dayjs from "dayjs";
import { storageLocal } from "../util/storage";

// 新游页面内容
const router = [
  {
    id: "new",
    title: "新游首发",
    view: New,
  },
  {
    id: "reserve",
    title: "新游预约",
    view: Reserve,
  },
];

export default (props) => {
  const [query] = useUrlState({});

  const [current, setCurrent] = useState(query.type || props.type || 0);

  useEffect(() => {
    if (query.type) {
      setCurrent(query.type);
    }
  }, [query.type]);

  const searchStartClick = async () => {
    console.log("新游搜索开始点击");

    // 同步生成二级kid
    let kid = await getKidCallback();
    // 存储二级kid
    sessionStorage.setItem("boxSecondKid", kid);

    // 行为上报
    // 一级kid、二级kid都进行传递
    let reamrk = {
      search_click_time: dayjs().unix(),
      search_click_position: "新游",
    };
    userClickReport({
      target_id: 1,
      parent_id: "",
      kid,
      level: 2,
      action_code: "search_click",
      remark: JSON.stringify(reamrk),
    });
  };

  return (
    <>
      <Link
        to="/search"
        className="show index-search-icon"
        onClick={searchStartClick}
      >
        <img src="/resources/common/search.png" alt="" />
      </Link>

      <div className="index-new">
        <div className="new-head width">
          {router.map((item, index) => (
            <div
              key={index}
              className={`item ${index == current ? "active" : ""}`}
              onClick={() => {
                setCurrent(index);
              }}
            >
              {item.title}
            </div>
          ))}
        </div>
        <div className="new-body">
          {router.map((item, index) => (
            <div
              key={index}
              className={`new-body-item ${index == current ? "active" : ""}`}
              style={{
                paddingBottom: storageLocal.has("kfUrl") ? "50px" : "0",
              }}
            >
              <Active active={props.active && index == current}>
                <item.view active={props.active && index == current} />
              </Active>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
